import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Container, Typography, useTheme } from '@mui/material';
import logoImage from '../../assets/images/logo.png';
import Footer from '../common/Footer';
import EnvironmentBadge from '../common/EnvironmentBadge';

const AuthLayout: React.FC = () => {
  const theme = useTheme();
  
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        bgcolor: theme.palette.smartSkillTalk.lightBlue,
        justifyContent: 'space-between',
      }}
      className="login-container"
    >
      <Container component="main" sx={{ 
        flexGrow: 1, 
        display: 'flex', 
        flexDirection: 'column',
        alignItems: 'center',
        padding: '50px 0',
      }} className="main-content">
        {/* キャッチフレーズ */}
        <Box className="catch-phrase" sx={{ width: '282px', mb: 1 }}>
          <Typography 
            component="p" 
            className="catch-phrase-text"
            sx={{ 
              color: theme.palette.smartSkillTalk.linkBlue,
            }}
          >
          </Typography>
        </Box>
        
        {/* ロゴ */}
        <Box className="logo" sx={{ 
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: '0px 10px 40px',
        }}>
          <EnvironmentBadge sx={{ marginBottom: '12px' }} />
          <Box 
            component="div"
            className="logo-image"
            sx={{ 
              width: '300px',
              height: '90px',
              backgroundImage: `url(${logoImage})`,
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
            }}
          />
        </Box>
        
        {/* コンテンツ */}
        <Box sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}>
          <Outlet />
        </Box>
      </Container>
      <Footer />
    </Box>
  );
};

export default AuthLayout;
